const StatusMap = {
    0: 'N/A',
    1: 'Workshop',
    2: 'Ready for deployment',
    3: 'Checked out',
    4: 'Operational',
    5: 'Disconnected',
    6: 'Fault',
    7: 'Checked in',
    8: 'Decommissioned',
}

const SubStatusMap = {
    0: '',
    11: 'Assembly',
    12: 'Refurbishment',
    13: 'Repair',
    14: 'R&D',
    31: 'Packed',
    32: 'Shipped',
    33: 'With customer',
    51: 'Unknown',
    52: 'Intentional',
    53: 'Out of battery',
    54: 'Damaged / destroyed',
    55: 'Lost connectivity',
    56: 'Stolen',
    61: 'GPS',
    62: 'One sensor not working',
    81: 'Destroyed / recycled',
    82: 'Faulty',
    83: 'R&D',
}

export { StatusMap, SubStatusMap };
